var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"hint"},[_vm._v("微信登录")]),_c('div',{staticClass:"we-chat",on:{"click":function($event){return _vm.onWXLogin()}}},[_c('img',{attrs:{"src":require("@/assets/images/weChat.png"),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }